import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-ademe-input',
    templateUrl: './ademe-input.component.html',
    styleUrls: ['./ademe-input.component.scss']
})
export class AdemeInputComponent {

    @Input() value = '';
    @Input() readonly = false;
    @Input() showImage = true;
    @Output() valueChange = new EventEmitter<string>();
}
